/* eslint-disable */
import { sanitizeEmailHtml, isEmailBodyEmpty } from "./sanitizer";
import { ParseHtml } from "./domAdapter";

export interface EmailTemplateWarning {
  code: string;
  message: string;
}

export interface EmailTemplateValidation {
  html: string;
  warnings: EmailTemplateWarning[];
}

export function sanitizeImportedEmailHtml(
  dirtyHtml: string,
  opts?: { parseHtml?: ParseHtml }
): EmailTemplateValidation {
  return { html: sanitizeEmailHtml(dirtyHtml, opts), warnings: [] };
}

export function validateEmailTemplateHtml(
  dirtyHtml: string,
  opts?: { parseHtml?: ParseHtml }
): EmailTemplateValidation {
  const result = sanitizeImportedEmailHtml(dirtyHtml, opts);
  if (isEmailBodyEmpty(result.html, opts)) {
    result.warnings.push({
      code: "empty-body",
      message: "After cleanup this template has no visible content.",
    });
  }
  return result;
}
